<template>
    <div id="Container_ePharmacyItemsReceived">
        <b-row>
            <b-col sm="12">
                <MdTitle
                    v-bind:Text="
                        this.editMode
                            ? $t('ePharmacyItemsReceived.EditItemReceived')
                            : $t('ePharmacyItemsReceived.AddItemReceived')
                    "
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('ePharmacyItemsReceived.BatchNo')"
                    v-bind:Name="'Program'"
                    v-bind:TypeProp="'text'"
                    v-model="itemEditable.batchno"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_dprogram_id'"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                    :Label="$t('Shared.ReceivedDate')"
                    :Model="itemEditable.receiveddate"
                    @input="itemEditable.receiveddate = $event"
                    :Id="'ItemReceivedddate'"
                    :Type="'date'"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="isReadOnly || !isEditable"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.InvoiceNumber')"
                    v-bind:Name="'invoiceNumber'"
                    v-bind:TypeProp="'text'"
                    v-model="itemEditable.invoiceNumber"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_invoiceNumber'"
                    v-bind:MaxLengthProp="30"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.PoNumber')"
                    v-bind:Name="'ponumber'"
                    v-bind:TypeProp="'number'"
                    v-model="itemEditable.ponumber"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_ponumber'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:ModelCode="itemEditable.vendorcode"
                    v-bind:ModelDescription="itemEditable.vendor.name"
                    v-bind:Label="$t('Shared.Vendor')"
                    v-bind:RefCode="'vendor_code'"
                    v-bind:Api="'Vendors?IsActive=true'"
                    v-bind:FieldCode="'vendorcode'"
                    v-bind:isValid="isVendorCodeValid"
                    v-bind:isRequired="false"
                    v-bind:FieldDescription="'vendorcode'"
                    :InvalidFeedback="TextVendorInvalidFeedback"
                    :SearchTitle="$t('Shared.Vendor')"
                    :GetValues="onCodeConditionOk"
                    :SearchFieldCode="'Code'"
                    v-bind:Fields="VendorBaseFields"
                    v-bind:AuxFields="vendorAuxFields"
                    v-bind:NoValidateChanges="false"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="12" md="12" sm="12">
                <MdMemo
                    v-bind:Label="$t('Shared.Comments')"
                    v-bind:VisibleLabel="true"
                    v-bind:Name="'textarea_comments'"
                    v-bind:Rows="'5'"
                    v-bind:MaxRows="'6'"
                    v-bind:MaxLength="'500'"
                    v-model="itemEditable.comments"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12" class="mt-2">
                <MdTitle
                    v-bind:Text="viewText"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="
                        this.isReadOnly
                            ? 'btn btn-primary my-3 btn-block'
                            : 'btn btn-primary my-3 btn-block btn-login'
                    "
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="addHandler"
                    v-bind:isReadOnly="this.isReadOnly"
                >
                </MdButton>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <MdTablePaginationClient
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:IsItemReceived="true"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    :RowClick="rowClickHandler"
                >
                </MdTablePaginationClient>
                <!--
                <MdEditableGrid
                    :ref="'editableGrid'"
                    v-bind:fields="fields"
                    v-model="items"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:header="true"
                    v-bind:edit="editAction"
                    :add="addAction"
                    :totalRows.sync="totalRows"
                    :validateRowCallback="validateRowHandler"
                >
                </MdEditableGrid>
            -->
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')"
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <!-- <MdButton
                v-bind:isReadOnly="items.length == 0"
                v-bind:Label="$t('Shared.Report')"
                v-bind:Name="'btnpatientlist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="showReport()"/> -->
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="
                    this.isReadOnly || !pendingChanges ? 'primary mx-2' : 'primary btn-login mx-2'
                "
                v-on:click="Save"
                v-bind:isReadOnly="isReadOnly || !pendingChanges || this.items.length === 0"
                v-bind:Name="'btn_save'"
            />
        </div>

        <eItemsReceivedEditDlg
            v-bind:visible="visibleEditDialog"
            v-model="editableItem"
            @close="closeHandler"
            @ok="okHandler"
            v-bind:drugBaseFields="DrugBaseFields"
            v-bind:drugAuxFields="DrugAuxFields"
            v-bind:locationBaseFields="LocationBaseFields"
        >
        </eItemsReceivedEditDlg>

        <BaseModal
            v-if="SignotecVisible"
            ModalId="SignotecModalId"
            :TitleWindow="`Sign`"
            :width="'30%'"
            :height="'auto'"
            :HideModalFun="SignotecOnCancel"
            @Close="SignotecOnCancel"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.TitleOK'), variant: 'primary', action: SignotecOnOK }
            ]"
        >
            <MdSignotec
                ref="mdSignotec"
                @OnSignotecSubmitImage="SignotecOnSubmitImage"
                @OnSignotecError="SignotecOnError"
                @OnSignotecConfirm="SignotecOnConfirm"
                @OnSignotecCancel="SignotecOnCancel"
            />
        </BaseModal>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import validationMixin from '@/common/validationMixin.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import ePharmacyItemsReceivedService from '@/services/epharmacyitemsreceived.service';
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import GlobalService from '@/services/global.service';
import eItemsReceivedEditDlg from './eItemsReceivedEditDlg';
import validationRules from '@/common/validationRules';
import EmployeeService from '@/services/employee.service';
import LocalStorage from '@/services/storage.service';

export default {
    name: 'ePharmacyItemsReceived',
    mixins: [DBFunctions, ShowMessage, validationMixin],
    props: ['editMode'],
    components: {
        eItemsReceivedEditDlg
    },

    data() {
        const defaultValue = {
            batchNo: null,
            description: null,
            expirationDate: null,
            itemCode: null,
            itemNo: null,
            itemTotal: null,
            location: null,
            lotNo: null,
            minOrder: null,
            quantityReceived: null,
            unitPrice: null
        };

        return {
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },
            fields: [
                {
                    key: 'description',
                    label: this.$tc('ePharmacyItemsReceived.Item', 1),
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: 'quantityReceived',
                    label: this.$t('Shared.QuantityReceived'),
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: 'uom',
                    label: this.$t('Shared.UOM'),
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: 'unitPrice',
                    label: this.$t('Shared.UnitPrice'),
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: 'lotNo',
                    label: this.$t('ePharmacyItemsReceived.LotNo'),
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: 'locationDescription',
                    label: this.$tc('ePharmacyItemsReceived.Location'),
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: 'expirationDate',
                    label: this.$t('Shared.ExpirationDate'),
                    class: 'text-center',
                    sortable: true,
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    }
                },
                {
                    key: 'itemTotal',
                    label: this.$t('Shared.TotalPrice'),
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: 'minOrder',
                    label: this.$t('ePharmacyItemsReceived.MinOrder'),
                    class: 'text-left',
                    sortable: true
                }
            ],
            items: [],
            customActions: [],
            customColumns: [],
            isReadOnly: false,
            isEditable: true,
            itemEditable: {
                batchno: '',
                invoiceNumber: '',
                ponumber: '',
                vendorcode: null,
                receiveddate: null,
                comments: null,
                vendor: {
                    name: null,
                    address1: null,
                    address2: null,
                    zip: null,
                    city: null,
                    state: null
                }
            },
            VendorBaseFields: [
                {
                    key: 'name',
                    sortable: true,
                    label: this.$t('Shared.Name')
                },
                {
                    key: 'vendorcode',
                    sortable: true,
                    label: this.$t('Shared.Code')
                },
                {
                    key: 'address1',
                    sortable: true,
                    label: this.$t('Shared.Address1')
                },
                {
                    key: 'address2',
                    sortable: true,
                    label: this.$t('Shared.Address2')
                },
                { key: 'zip', sortable: true, label: this.$t('Shared.Zip') },
                {
                    key: 'city',
                    sortable: true,
                    label: this.$t('Shared.City')
                },
                {
                    key: 'state',
                    sortable: true,
                    label: this.$t('Shared.State')
                }
            ],
            vendorAuxFields: ['address1', 'address2', 'zip', 'city', 'state', 'name'],
            isVendorCodeValid: true,
            TextVendorInvalidFeedback: '',
            LocationBaseFields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name') },
                { key: 'code', sortable: true, label: this.$tc('Shared.Code') }
            ],
            DrugBaseFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description') },
                { key: 'itemCode', sortable: true, label: this.$t('Shared.Code') }
            ],
            DrugAuxFields: ['purchaseUOM', 'description', 'minOrderQty', 'dispensingUnitCost'],
            pendingChanges: false,
            visibleEditDialog: false,
            editableItem: null,
            editableIndex: -1,
            defaultItem: defaultValue,
            totalRows: 0,
            showMessageIsEmpty: false,
            pageOptions: [5, 10, 15],
            perPage: 10,
            currentPage: 1,
            parameters: {
                addedItems: [],
                deletedItems: [],
                editedItems: []
            },
            isValidReceivedDate: true,
            SignotecEnabled: false,
            SignotecVisible: false,
            SignotecSignatureFile: null
        };
    },

    computed: {
        editableGrid() {
            const tableComponent = this.$refs['editableGrid'];
            return Array.isArray(tableComponent) ? tableComponent[0] : tableComponent;
        },

        editableItemMode() {
            return this.editableIndex !== -1;
        },
        viewText() {
            const quantityReceived = this.items.reduce(
                (sum, item) => sum + +item.quantityReceived || 0,
                0
            );
            return `${this.$t('Shared.Details')} - ${this.$t(
                'Shared.QuantityReceived'
            )}: ${quantityReceived}`;
        }
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
        },

        onRowSelected() {},

        rowClickHandler() {},

        goBack() {
            this.$router.push({ name: 'ePharmacyItemsReceived' });
        },

        editHandler(value) {
            this.editableIndex = this.items.findIndex(item => item === value);
            this.editableItem = value;
            this.visibleEditDialog = true;
        },

        addHandler() {
            this.editableIndex = -1;
            this.editableItem = { ...this.defaultItem };
            this.visibleEditDialog = true;
        },

        deleteHandler(row) {
            const itemNo = row.itemNo;
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_items'
                })
                .then(value => {
                    if (value) {
                        const index = this.items.findIndex(item => item === row); // find the post index
                        if (~index) {
                            // if the post exists in array
                            this.items.splice(index, 1); //delete the post and refresh view
                            this.totalRows = this.items.length;

                            if (itemNo) {
                                this.parameters.deletedItems.push(itemNo);
                            }

                            this.pendingChanges = true;
                        }
                    }
                });
        },

        okHandler() {
            this.visibleEditDialog = false;

            if (this.editableItemMode) {
                const currentItem = this.items[this.editableIndex];
                const updated =
                    currentItem.itemCode !== this.editableItem.itemCode ||
                    currentItem.quantityReceived !== this.editableItem.quantityReceived ||
                    currentItem.unitPrice !== this.editableItem.unitPrice ||
                    currentItem.lotNo !== this.editableItem.lotNo ||
                    currentItem.location !== this.editableItem.location ||
                    currentItem.locationDescription !== this.editableItem.locationDescription ||
                    currentItem.expirationDate !== this.editableItem.expirationDate;

                if (updated) {
                    this.$set(this.items, this.editableIndex, this.editableItem);

                    if (this.editableItem.itemNo !== null) {
                        this.parameters.editedItems.push(this.editableItem.itemNo);
                    }

                    this.pendingChanges = true;
                }
            } else {
                this.items.push({ ...this.editableItem });
                this.totalRows = this.items.length;
                this.pendingChanges = true;
            }
        },

        closeHandler() {
            this.visibleEditDialog = false;
        },

        onCodeConditionOk(result) {
            const type = result.FieldName;
            const containAuxFields = result.AuxFields && result.AuxFields.length > 0;

            if (type.indexOf('vendor_code') >= 0) {
                this.itemEditable.vendorcode = result.code;
                this.itemEditable.vendor.name = containAuxFields ? result.AuxFields[5] : null;
                this.itemEditable.vendor.address1 = containAuxFields ? result.AuxFields[0] : null;
                this.itemEditable.vendor.address2 = containAuxFields ? result.AuxFields[1] : null;
                this.itemEditable.vendor.zip = containAuxFields ? result.AuxFields[2] : null;
                this.itemEditable.vendor.city = containAuxFields ? result.AuxFields[3] : null;
                this.itemEditable.vendor.state = containAuxFields ? result.AuxFields[4] : null;
            } else if (type.indexOf('location') >= 0) {
                const location = type.split('_');
                const index = location[location.length - 2];
                this.items[index].location = result.code;
            } else if (type.indexOf('itemCode') >= 0) {
                const value = type.split('_');
                const index = value[value.length - 2];
                this.items[index].itemCode = result.code.trim();
                this.items[index].description = result.description;
                this.items[index].uom = containAuxFields ? result.AuxFields[0] : null;
                this.items[index].minOrder = containAuxFields ? result.AuxFields[2] : null;
                this.items[index].unitPrice = containAuxFields ? result.AuxFields[3] : null;
            }
        },

        Save() {
            if (this.validate_required()) {
                if (this.validate_details()) {
                    if (
                        this.editMode ||
                        this.SignotecEnabled == false ||
                        this.SignotecSignatureFile
                    ) {
                        this.SaveFinal();
                    } else {
                        this.SignotecVisible = true;
                    }
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('ePharmacyItemsReceived.InvalidItemsDetailQuantity'),
                        'errorAutoHide'
                    );
                }
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        SaveFinal() {
            if (this.editMode) {
                this.UpdateItemReceived();
            } else {
                this.AddItemReceived();
            }
        },

        UpdateItemReceived() {
            let data = { ...this.itemEditable };
            data.ponumber =
                Utils.isNullOrEmptyString(data.ponumber) || !parseInt(data.ponumber)
                    ? null
                    : +data.ponumber;

            let details = [...this.items];
            details.forEach(element => {
                element.unitPrice = +element.unitPrice;
                element.quantityReceived = +element.quantityReceived;
            });

            //  const deletedArray = [...new Set(this.parameters.deletedItems)];
            //  const updatedArray = [...new Set(this.parameters.editedItems)];
            /* data.itemReceivedDetails = {
              //  deletedItems: deletedArray,
                addedItems: details.filter(element => element.itemNo === null || element.itemNo === undefined),
              //  updatedItems: details.filter(element => updatedArray.some(data => data === element.itemNo))
            }*/

            data.itemReceivedDetails = details.filter(
                element => element.itemNo === null || element.itemNo === undefined
            );
            delete data.vendor;

            ePharmacyItemsReceivedService
                .Update(this.itemEditable.recID, data)
                .then(response => {
                    if (response.status == '200') {
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        });

                        this.pendingChanges = false;
                        this.goBack();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        AddItemReceived() {
            let data = { ...this.itemEditable };
            data.ponumber =
                Utils.isNullOrEmptyString(data.ponumber) || !parseInt(data.ponumber)
                    ? null
                    : +data.ponumber;

            let details = [...this.items];
            details.forEach(element => {
                element.unitPrice = +element.unitPrice;
                element.quantityReceived = +element.quantityReceived;
            });

            data.itemReceivedDetails = details;
            delete data.vendor;

            data.Signature = this.SignotecSignatureFile;

            ePharmacyItemsReceivedService
                .Add(data)
                .then(response => {
                    if (response.status == '200') {
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        });

                        this.pendingChanges = false;
                        this.goBack();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            const rules = {
                receiveddate: [validationRules.date(null, this.$t('Msg.InvalidDate'))]
            };

            return this.validateFields(rules, this.itemEditable) && this.isValidReceivedDate;
        },

        validate_details() {
            return this.items.length !== 0;
        },

        async getItemReceivedByRecId() {
            await ePharmacyItemsReceivedService
                .Get(this.$route.params.recId)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        var data = response.data;
                        data.vendorcode = data.vendorcode ?? '';

                        if (data.ponumber) {
                            data.ponumber = `${data.ponumber}`;
                        }

                        this.itemEditable = data;
                        this.itemEditable.vendor = {
                            name: data.vendor?.name,
                            address1: data.vendor?.address1,
                            address2: data.vendor?.address2,
                            zip: data.vendor?.zip,
                            city: data.vendor?.city,
                            state: data.vendor?.state
                        };

                        this.items = [];
                        data.itemReceivedDetails.forEach(element => {
                            this.items.push({
                                expirationDate: Utils.formatterDate(element.expirationDate),
                                itemCode: element.itemcode,
                                location: element.location,
                                locationDescription: element.locationDescription,
                                lotNo: element.lotNo,
                                quantityReceived: `${element.quantityReceived}`,
                                unitPrice: `${element.unitprice}`,
                                itemTotal: element.total,
                                minOrder: element.minOrderQty,
                                description: element.itemDescription,
                                itemNo: element.itemNo,
                                batchNo: element.batchno
                            });
                        });

                        delete this.itemEditable.itemReceivedDetails;
                        this.totalRows = this.items.length;
                        this.showMessageIsEmpty = this.items.length === 0;

                        this.itemEditable.receiveddate = data.receiveddate;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getDateTime() {
            if (!this.edit_mode) {
                GlobalService.getDateTime()
                    .then(response => {
                        if (response.data) {
                            this.itemEditable.receiveddate = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        showReport() {},

        SignotecOnOK() {
            if (!this.SignotecSignatureFile) {
                this.$refs.mdSignotec.confirm();
            }
        },

        SignotecOnCancel() {
            this.SignotecVisible = false;
            this.SignotecSignatureFile = null;
        },

        SignotecOnConfirm() {
            if (this.SignotecSignatureFile) {
                this.SignotecVisible = false;
                this.SaveFinal();
            } else {
                this.showMessage(this.$tc('Msg.Error'), 'Please sign', 'error');
            }
        },

        SignotecOnSubmitImage(data) {
            this.SignotecSignatureFile = data;
        },

        SignotecOnError(msg) {
            this.showMessage(this.$tc('Msg.Error'), msg, 'error');
        }
    },

    async mounted() {
        if (this.editMode) {
            await this.getItemReceivedByRecId();
        } else {
            await this.getDateTime();
            const UserId = LocalStorage.getUserId();
            EmployeeService.GetByUserId(UserId)
                .then(response => {
                    if (response.data) {
                        let result = response.data;
                        if (
                            result &&
                            result.requestSigReceivedItems &&
                            result.signaturePad == 'Signotec'
                        ) {
                            this.SignotecEnabled = true;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }

        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges |= e.Changed;
            }.bind(this)
        );
    },

    beforeDestroy() {
        EventBus.$off('onChanged');
    },

    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.editMode
                        ? this.$t('ePharmacyItemsReceived.EditItemReceived')
                        : this.$t('ePharmacyItemsReceived.AddItemReceived'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        next();
                    } else {
                        this.Save();
                    }
                });
        } else {
            next();
        }
    }
};
</script>
